module.exports = __webpack_public_path__ + "img/img10.3252ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img10.png
// module id = 50
// module chunks = 0